import(/* webpackMode: "eager", webpackExports: ["AnimatedLeaderboard"] */ "/vercel/path0/app/leaderboard/animated-leaderboard.tsx");
